import React, { useContext } from 'react';
import styled from 'styled-components/macro';

import { palette } from '@mirinae/react-ui';
import GlobalContext from '@mirinae/lessons/modules/contexts/global';
import { UserAgent, ExternalLinks } from '@mirinae/js-utils';
import { useAppVersionStore } from '@mirinae/stores/appVersion';

import BgStars from '@mirinae/lessons/assets/images/bg-button-pattern-stars.png';
import { lessonsPaths, explorerPaths, membersPaths, authPaths} from '@mirinae/shared/defines/paths';
// import Localization from 'i18n';

const Element = styled.a`
    display: block;
    height: 47px;
    line-height: 47px;
    min-width: fit-content;
    padding: 0 15px;
    color: ${palette.primary.white};
    font-size: 14px;
    font-weight: 700;
    background: url(${BgStars}) no-repeat 0 0/cover, linear-gradient(90deg, #0093C1 -70.26%, #42569B 121.84%);
    box-shadow: 0 4px 18px rgba(40, 96, 162, 0.37);
    border-radius: 10px;
    white-space: nowrap;
    text-align: center;
    cursor: pointer;
    :hover {
        background: url(${BgStars}) no-repeat 0 0/cover, linear-gradient(90deg, #275393 -70.26%, #293168 121.84%);
    }
    :disabled {
        background-color: ${palette.gray[6]};
    }
`;

const TryFreeButton = () => {
    const global = useContext(GlobalContext);
    const isApp = useAppVersionStore(state => state.isApp);
    const isPricePlan3PlusEnabled = useAppVersionStore(state => state.isPricePlan3PlusEnabled);

    if (isApp && isPricePlan3PlusEnabled) {
        return (
            <Element onClick={(e) => {
                e.preventDefault();
                if (window.PaymentChannel) {
                    window.PaymentChannel.postMessage(true); 
                } else if (window.flutter_inappwebview) {
                    window.flutter_inappwebview.callHandler('PaymentChannel', true);
                }
            }}>
                Subscribe to Pro now
            </Element>
        );
    }
    return !isApp ? (
        <Element href={membersPaths.payment}>Subscribe to Pro now</Element>
    ) : (
        <Element href={UserAgent.os.isAndroid ? ExternalLinks.app.android : ExternalLinks.app.apple}>Install the latest app to enable Pro</Element>
    );
};

export default TryFreeButton;